import React from 'react';
import { CircularProgress } from '@mui/material';
import { StatusTitle, StatusWrap } from './styles';

const statusLabelMap = {
  online: 'ONLINE',
  offline: 'OFFLINE',
};

function OnlineStatusComponent(props) {
  const { status = 'offline', snapshotLoading } = props;

  return (
    <StatusWrap>
      <StatusTitle className={status}>
        {snapshotLoading
          ? (
            <CircularProgress
              size={12}
              className="loader"
            />
          )
          : <div className="indicator" />}
        {statusLabelMap[status]}
      </StatusTitle>
    </StatusWrap>
  );
}

export default OnlineStatusComponent;
